export const words = {
  place: "Konum",
  yes: "Evet",
  no: "Hayır",
  new: "Yeni",
  agb: 'AGB',
  agb_full: "Genel hüküm ve koşullar",
  datenschutzerklaerung: "Gizlilik Politikası",
  status: "Durum",
  company_name: "Şirket adı",
  next_button: "Daha ileri",
  device_name: "Cihaz adı",
  to_connect: "Bağlan",
  pin: 'PIN',
  time: "Zaman",
  first_name: "İlk isim",
  last_name: "Soyadı",
  code: "Kod",
  help: "Yardım",
  total_time: "Toplam süre",
  latitude: "Enlem",
  longitude: "Boylam",
  accuracy: "Doğruluk",
  timestamp: "Zaman Damgası",
  device_id: "Cihaz Kimliği",
  active: "aktif",
  o_clock: "Saat",
  loading: "Mağaza",
  annotation: "Not",
  since: "beri",
  camera: 'Kamera',
  map: "Harita",
  gallery: "Galeri",
  work: "İş",
  employees: "Çalışanlar",
  login: "Kayıt",
  login_action: "Giriş yap",
  calendar_week_abbreviation: 'KW',
  calendar: "Takvim",
  to_call: "Arayın",
  email: "E-posta",
  attachment: "Ekler",
  operational_planning: "Operasyonel plan",
  to_scan: "Tarama",
  download: "İndir",
  export: "İhracat",
  to_document: "Belge",
  checklist: "Kontrol Listesi",
  checklists: "Kontrol Listeleri",
  password: "Şifre",
  confirmation: "Onaylama",
  confirm: "Onaylayın",
  confirmation_email: "Onay e-postası",
  unknown: "Bilinmeyen",
  unknown_place: "Bilinmeyen yer",
  unknown_plan: "İsimsiz vardiya takvimi",
  project_no: "Proje no.",
  project_file: "Proje dosyası",
  contact_person: "İletişim",
  overtime: "Fazla Mesai",
  timesheet: "Zaman Çizelgesi",
  minustime: "Eksi saatler",
  back: "Geri",
  undo: "Geri al",
  clockout: "Damga vurun",
  clocked_out: "damgalı",
  clockin: "Pul içeri",
  clocked_in: "damgalı",
  dismiss: "İptal",
  discard: "Reddetmek",
  finish: "Hazır",
  or: "veya",
  copy: "Kopya etmek",
  qr_code: "QR kodu",
  documentation: "Zaman kaydı ve dokümantasyon",
  attendance: "Tablet terminali",
  tiercontent: "Paket kapsamı",
  start_now: "Şimdi başlayın",
  skip: "atlamak",
  logout_during_core_time: "Çekirdek zamanı sırasında damgalandı",
  absent_during_core_time: "Çekirdek zaman boyunca yok",
  distance: "Mesafe",
  km_reading: "Kilometre",
  the_start: "Başlangıç",
  the_end: "Bitiş",
  license_plate: "Plaka",
  details: "DETAYLAR",
  hide: "Gizle",
  cost: "Maliyetler",
  file: "Dosya",
  address_book: "Adres defteri",
  template_plural: "Şablonlar",
  signature: "İmza",
  main_project: "Ana proje",
  main_projects: "Ana projeler",
  sub_projects: "Alt Projeler",
  scan_to_login_header: "QR kod kaydı",
  description: "Açıklama",
  project_location: "Proje konumu",
  phone_number: "Telefon numarası",
  project_info: "Proje bilgileri",
  number_short: "Hayır.",
  sketch: "Eskiz",
  video: 'Video',
  delete: "Silme",
  send: "Gönder",
  sending: "Gönder...",
  save: "Kaydet",
  granted: "ONAYLANDI",
  pending: "talep edildi",
  denied: "Reddedildi",
  customer: "Müşteri",
  mobile_number: "Telefon numarası",
  ok: "Tamam.",
  day: "Gün",
  tomorrow: "Sabah",
  days: "Gün | Gün | Gün",
  holidays: "Tatiller",
  vacation_days: "Tatiller",
  vacation_hours: "Tatil saatleri",
  request: "İstek",
  accept: "Kabul et",
  withdraw: "Ayırmak",
  hour_account: "Saatlik hesap",
  period: "Dönem",
  to: "için",
  date: "Randevu",
  number: "Sayı",
  message: "Mesaj",
  change: "değişim",
  changed: "Değişti",
  changed_fields: "Değişen alanlar",
  type: "Sanat",
  hour: "Saat",
  hours: "Saatler",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Saatler",
  end: "son",
  end_date: "Son teslim tarihi",
  start_date: "Başlangıç tarihi",
  absence: "Devamsızlık",
  month: "ay",
  week: "Hafta",
  transcript: 'Transkript',
  time_left: "Kalan",
  transcript_tasks: "Görev",
  add_task: "Yeni",
  /** Differentiation in some languages (e.g. English) */
  from: "gelen",
  of: "gelen",
  of_hours: "{hours} adresinden",
  of_hours_abbreviation: "{hours} saatlerden.",
  /**************/

  used: "kullanılmış",
  update: "Güncelleme",
  today: "bugün",
  correction: "Düzeltme",
  work_time: "Çalışma süresi",
  break: "Mola",
  loading_time: "Yükleme süresi",
  driving_time: "Seyahat süresi",
  business_trip: "Görev süresi",
  project: "Proje",
  special_one: "Özel1",
  special_two: "Özel2",
  clock: "Saat",
  search: "Arama",
  operation: "Etkinlik",
  day_protocol: "Günlük protokol",
  continue: "daha fazla",
  total_duration: "Toplam süre",
  duration: "Süre",
  hello: "Merhaba",
  close: "Kapat",
  comment: "Yorum",
  small: "küçük",
  medium: "orta",
  large: "büyük",
  sharpie: "Pim",
  line: "Hat",
  arrow: "Ok",
  rectangle: "Dikdörtgen",
  ellipse: "Elips",
  text: "Metin",
  language_settings: "Dil ayarları",
  clock_reminder: "Pul hatırlatıcısı",
  individually: "Birey",
  from_o_clock: "gelen",
  to_o_clock: "için",
  eraser: "Silgi",
  edit: "Düzenle",
  legal_notes: "Yasal",
  notes: "Notlar",
  note: "Not",
  imprint: "Künye",
  open_source_licenses: "Açık Kaynak Lisans Koşulları",
  author: "Yazar",
  license_type: "Lisans türü",
  version: "Versiyon",
  substitute: "Temsilcilik",
  not_rated: "Derecelendirilmemiş",
  weekly_working_hours: "Haftalık çalışma saatleri",
  show_less: "Daha az göster",
  office_center: "Ofis Merkezi",
  admin_view: "NFC yönetimi",
  register: "Kayıt",
  shifts: {
    shift_attachments: "Ekler (katman)",
    shift_plan_attachments: "Eklentiler (vardiya planı)",
    shift_plan: "Vardiya programı",
    shift: "Tabaka"
  },
  absences: {
    sick: "Hastalık (ücretlerin ödenmeye devam edilmesi)",
    vacation: "Tatil",
    workshop: "Seminer/Kurs",
    special_vacation: "Özel izin",
    school: "Okul",
    working_time_account: "Çalışma süresi hesabı",
    holiday: "Tatil",
    other: "Diğer",
    driving_time: "Seyahat süresi",
    parental_leave: "Ebeveyn izni",
    excused_absent: "Mazeretli devamsız (ücretli)",
    not_excused_absent: "Mazeretsiz devamsızlık",
    sick_industrial_accident: "Hastalık Endüstriyel kaza (LFZ)",
    short_time_work: "Kısa süreli çalışma (Kug)",
    maternity_pay: "Annelik koruması ücret/istihdam yasağı",
    sick_child: "Hasta bir çocuğa hastalık (günlük) maaşı ile bakmak",
    sick_child_no_payment: "Hasta bir çocuğa hastalık (günlük) ücreti olmadan bakmak",
    vacation_no_payment: "Ücretsiz izin",
    sick_before_short_time_work: "Kug öncesi hastalık yardımı/hastalık",
    weather_related_failure: "Hava koşulları nedeniyle arıza",
    sick_short_time_work: "Kug sırasında hastalık",
    sick_no_payment: "Hastalık (ücret ödemesi devam etmeden)",
    company_vacation: "Şirket tatilleri",
    meals_14_euro: "Küçük ikram ödeneği",
    meals_28_euro: "Geniş ikram ödeneği"
  },
  image_editor: {
    font_size: "Yazı tipi boyutu",
    stroke_width: "Çizgi genişliği",
    stroke_color: "Çizgi rengi",
    text_color: "Yazı tipi rengi",
    rotate_left: "Sola dönün",
    rotate_right: "Sağa dönün",
    flip_horizontal: "Yatay ayna",
    flip_vertical: "Dikey ayna"
  },
  travel_log: {
    method_of_transportation: "Ulaşım araçları",
    company_car: "Şirket arabası",
    private_car: "Özel araç",
    rental_car: "Kiralık araba",
    taxi: "Taksi",
    public_transportation: "Toplu taşıma",
    airplane: "Uçak",
    train: "Demiryolu (uzun mesafeli toplu taşıma)",
    other: "Diğer",
    km_reading_start: "Kilometre başlangıcı",
    km_reading_end: "Kilometre sonu",
    net_expenses: "Seyahat giderleri (net)",
    tax: "Katma değer vergisi"
  },
  read_in: "Okuyun",
  currency: "Para Birimi",
  reason: "Sebep",
  label: "Etiket",
  monday: "Pazartesi",
  tuesday: "Salı",
  wednesday: "Çarşamba",
  thursday: "Perşembe",
  friday: "Cuma",
  saturday: "Cumartesi",
  sunday: "Pazar",
  break_alarm: "Alarm saatini kır",
  clockin_reminder: "Saat açılışı hatırlatıcısı",
  clockout_reminder: "Abonelikten Çıkma Hatırlatması"
};